"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const core_1 = require("companion-app-components/utils/core");
const actions = __importStar(require("data/apiUtil/actions"));
const styledComponents_1 = require("./styledComponents");
const log = (0, core_1.getLogger)('components/AccountsList/index.tsx');
const DocumentBrowser = ({ documents, onClose, selectedIds }) => {
    const [images, setImages] = (0, react_1.useState)([]);
    const dispatch = (0, react_redux_1.useDispatch)();
    const reqReturn = (err, data, id) => {
        var _a;
        if (err) {
            log.log(err);
            // error 400 means the docID has been deleted
            if (((_a = err.response) === null || _a === void 0 ? void 0 : _a.status) === 400) {
                setImages((prevImages) => [
                    ...prevImages,
                    { id, url: 'unavailable', name: 'unavailable' },
                ]);
            }
        }
        else {
            setImages((prevImages) => {
                if (!prevImages.find((item) => item.id === id)) {
                    return [...prevImages, { id, url: data.data.url, name: data.data.name }];
                }
                return prevImages;
            });
        }
    };
    const processProps = (docs) => {
        log.log('Process Props', docs);
        if (docs && docs.length > 0) {
            docs.forEach((docObj) => {
                const path = `documents/${docObj.id}/original`;
                const obj = {
                    reqId: docObj.id,
                    path,
                    data: null,
                    verb: 'get',
                    cb: reqReturn,
                };
                log.log('Make API Call to:', obj);
                dispatch(actions.makeQCSApiCall(obj));
            });
        }
        else {
            setImages([]);
            onClose();
        }
    };
    (0, react_1.useEffect)(() => {
        processProps(documents);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documents]);
    return (<Dialog_1.default fullWidth open onClose={onClose} aria-labelledby="responsive-dialog-title">
      <DialogTitle_1.default display="flex" justifyContent="space-between" alignItems="center">
        View Attachments
        <IconButton_1.default title="Close" aria-label="Close" onClick={onClose}>
          <Close_1.default />
        </IconButton_1.default>
      </DialogTitle_1.default>
      <styledComponents_1.ImageGalleryStyled id="qimg-gallery" images={images} selectedImages={selectedIds}/>
    </Dialog_1.default>);
};
exports.default = DocumentBrowser;
